<template>
  <div v-if="item.childs.length===0">
    <v-sheet color="transparent" height="48" :style="{marginLeft:(level*24)+'px'}">
      <v-row no-gutters align="center" class="fill-height px-4">
        <v-col cols="auto">
          <v-checkbox
              :disabled="parentSelected"
              @click.stop="$tools.selectToggle(permsSelected, item);childsUpdate(item)"
              :input-value="parentSelected || $tools.isSelect(permsSelected, item)"
              hide-details class="ma-0" dense
          />
        </v-col>
        <v-col class="font-weight-medium body-2">
          {{item.name}}
        </v-col>
        <v-col cols="auto">
          <chip v-if="$tools.isSelect(permsSelected, item)" color="green" dark>
            Разрешено
          </chip>
          <chip v-if="checkChilds(item)" color="green" dark class="ml-2">
            Частичный доступ
          </chip>
        </v-col>
        <v-col cols="auto">
          <v-sheet width="40"/>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
  <v-expansion-panels accordion v-else>
    <v-expansion-panel>
      <v-expansion-panel-header class="py-0 pl-0 pr-4">
        <v-sheet color="transparent" height="48" :style="{marginLeft:(level*24)+'px'}">
          <v-row no-gutters align="center" class="fill-height px-4">
            <v-col cols="auto">
              <v-checkbox
                  :disabled="parentSelected"
                  @click.stop="$tools.selectToggle(permsSelected, item);childsUpdate(item)"
                  :input-value="parentSelected || $tools.isSelect(permsSelected, item)"
                  hide-details class="ma-0" dense
              />
            </v-col>
            <v-col class="font-weight-medium body-2">
              {{item.name}}
            </v-col>
            <v-col cols="auto">
              <chip v-if="$tools.isSelect(permsSelected, item)" color="green" dark>
                Разрешено
              </chip>
              <chip v-if="checkChilds(item)" color="green" dark class="ml-2">
                Частичный доступ
              </chip>
            </v-col>
          </v-row>
        </v-sheet>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="mb-n4">
          <div v-for="(v,k) in item.childs" :key="v.id" class="mx-n6">
            <user-perm
                :item="v"
                :level="level+1"
                :permsSelected="permsSelected"
                :parentSelected="parentSelected || $tools.isSelect(permsSelected, item)"
            />
            <v-divider v-if="k<item.childs.length-1"/>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import Chip from "@/componentsV2/base/Chip.vue";

export default {
  components: {Chip, UserPerm: () => import('@/views/User/UserPerm.vue')},
  props:['item','level','permsSelected','parentSelected'],
  methods:{
    checkChilds(item){
      let res = false;
      item.childs.forEach(v1=>{
        if(this.$tools.isSelect(this.permsSelected, v1))
          res = true;
        if(this.checkChilds(v1))
          res = true;
      })
      return res;
    },
    childsUpdate(item){
      let unactive = (item1)=>{
        if(this.$tools.isSelect(this.permsSelected, item1))
          this.$tools.selectToggle(this.permsSelected, item1)
        item1.childs.forEach(v=>{
          unactive(v)
        })
      };
      item.childs.forEach(v=>{
        unactive(v)
      })
    }
  }
}
</script>